module.exports = __webpack_public_path__ + "static/media/4.dda696d8.jpg";